import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// Utils.
import { isWebviewApp, isMobile } from 'utils';

export default class WelltoryLink extends PureComponent {

  static propTypes = {
    to: PropTypes.object.isRequired,
    onClickLink: PropTypes.func,
  };

  constructor() {
    super();

    this.isWebviewAppStatus = isWebviewApp();
    this.isMobileStatus = isMobile();
  };

  getLinkByURL = (url, children, style, id, className) => {
    let to = '';
    if (typeof url === 'string') {
      to = url;
    }
    else if (typeof url === 'object') {
      to = url.pathname;
    }
    let link = null;
    if (!to || to.length === 0) {
      return link;
    }
    if (/welltory:\/\//.test(to) === true && this.isMobileStatus === true) {
      // if (/Payment\//.test(to) === true) {
      //   const pos = to.lastIndexOf('Payment/');
      //   to = to.substring(0, pos + 7);
      // }
      link = (
        <a
          href={to}
          target="_blank"
          rel="nofollow noopener"
          style={style}
          id={id}
          className={className}
          onClick={this.onClick}
        >
          {children}
        </a>
      );
    }
    else if (/welltory:\/\//.test(to) === true && this.isWebviewAppStatus === false) {
      let webURL = decodeURIComponent(to).replace(/welltory:\/\/branch/, '').replace('//', '/').toLowerCase();
      link = (
        <Link
          to={webURL}
          style={style}
          id={id}
          className={className}
          onClick={this.onClick}
        >
          {children}
        </Link>
      );
    }
    else if (to.charAt(0) === '/') {
      link = (
        <Link
          to={url}
          style={style}
          id={id}
          className={className}
          onClick={this.onClick}
        >
          {children}
        </Link>
      );
    }
    else {
      let webURL = to;
      if (typeof url === 'object' && url.search && url.search.length > 0) {
        webURL = `${webURL}?${url.search}`;
      }
      let target;
      if (/app.welltory.com/.test(webURL) === true) {
        target = '_self';
      }
      else {
        target = '_blank';
      }
      link = (
        <a
          href={webURL}
          target={target}
          rel="nofollow noopener"
          style={style}
          id={id}
          className={className}
          onClick={this.onClick}
        >
          {children}
        </a>
      );
    }
    return link;
  };

  onClick = () => {
    if (typeof this.props.onClick === 'function') {
      this.props.onClick();
    }
  }

  render() {
    const { to, children, style, id, className } = this.props;
    const link = this.getLinkByURL(to, children, style, id, className);
    return link;
  }

}
